<div class="modal-backdrop" (click)="close.emit()">
  <div
    class="profile-modal"
    role="dialog"
    aria-modal="true"
    aria-label="Edit profile"
    (click)="$event.stopPropagation()"
  >
    <h2 class="modal-title">Edit Profile</h2>

    <div class="avatar-row">
      <div class="avatar-wrap" (click)="pickerOpen.set(true)">
        <app-user-avatar
          [name]="editingName() || displayName()"
          [avatarUrl]="editingAvatarUrl()"
        />
        <div class="avatar-overlay" aria-hidden="true">
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M12 20h9" />
            <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4Z" />
          </svg>
        </div>
      </div>

      <div class="avatar-actions">
        <button type="button" class="btn-choose" (click)="pickerOpen.set(true)">
          Choose Avatar
        </button>
        <label class="btn-upload">
          <input
            type="file"
            accept="image/*"
            class="sr-only"
            (change)="handleEditAvatar($event)"
          />
          Upload Photo
        </label>
        @if (isUploadedPhoto()) {
          <button type="button" class="btn-remove" (click)="removeEditAvatar()">
            Remove photo
          </button>
        }
      </div>
    </div>

    <div class="modal-field">
      <label class="field-label">Display Name</label>
      <input
        type="text"
        [ngModel]="editingName()"
        (ngModelChange)="editingName.set($event)"
        maxlength="40"
        placeholder="Your name…"
      />
    </div>

    <div class="modal-actions">
      <button type="button" class="btn-cancel" (click)="close.emit()">
        Cancel
      </button>
      <button
        type="button"
        class="btn-save"
        [disabled]="editingName().trim().length < 2"
        (click)="onSave()"
      >
        Save
      </button>
    </div>
  </div>
</div>

@if (pickerOpen()) {
  <app-avatar-picker
    [currentUrl]="editingAvatarUrl()"
    (select)="onPickerSelect($event)"
    (cancel)="pickerOpen.set(false)"
  />
}
